import React, { useState } from 'react';
import { Typography } from '@/ui-kit';
import styles from './introA.module.scss';
import commonIntroStyles from '@/components/intro/intro.module.css';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { ArrowBackIcon } from '@/assets/icons';
import introAVideo from '@/assets/videos/introAVideo.mp4';
import { routesApp } from '@/constans/routes';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';
import { useIntroRedirects } from '../useIntroRedirects';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { useTranslation } from 'react-i18next';
import { LangSelector } from '@/components/lang-selector/lang-selector';
import '@/components/intro/intro.module.css';
import { IntroAGradient } from '../components/introAGradient';

export const IntroA: React.FC = () => {
    const { user } = useAuth((state) => state);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isVideoLoaded, setVideoLoaded] = useState(false)

    useIntroRedirects('A')

    const { isVibrationEnabled } =
        useVibration(state => state);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        )
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    return (
        <section className={styles.intro}>
            {
                isVideoLoaded ?
                    <></>
                :
                    <div className={styles.introVideoPoster} />
            }
            <video
                className={styles.introVideo}
                autoPlay={true}
                muted
                loop
                onLoadedData={() => setVideoLoaded(true)}>
                <source src={introAVideo} type="video/mp4" />
            </video>
            <IntroAGradient />
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h1">
                    {t('registration.find_your_soulmate')}
                </Typography>
                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}>
                    {t('registration.dating_for_those_who_love_to_travel_together')}
                </Typography>
                <div className={styles.intro__btn} onClick={registerClick}>
                    <span>
                        {t('registration.find_your_love')}
                    </span>
                    <button className={styles.intro__btnTrailing}>
                        <ArrowBackIcon className={styles.intro__btnTrailingIcon} />
                    </button>
                </div>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_accept_the_user_registration_terms')}
                </Typography>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_agree_with_terms.intro_common')}
                </Typography>
            </div>
            <LangSelector className={commonIntroStyles.langSelector} />
        </section>
    );
};
